import React, { useEffect, useState, useRef } from 'react';
import { Navbar } from 'react-bootstrap';
import { PersonCircle, ChevronDown, BoxArrowRight, Database } from 'react-bootstrap-icons';
import { FaUser, FaUsers, FaBook, FaChartLine } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import UserManualModal from '../UserManualModal2';

function Header() {
    const { user, logout } = useAuth();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [modernAlert, setModernAlert] = useState({ show: false, type: '', message: '' });
    const [showManualModal, setShowManualModal] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    /**
     * Show modern alert notification
     *
     * @param {string} message - Message to display
     * @param {string} type - Alert type ('success' or 'error')
     */
    const showModernAlert = (message, type = 'success') => {
        setModernAlert({ show: true, type, message });
        setTimeout(() => {
            setModernAlert({ show: false, type: '', message: '' });
        }, 5000);
    };

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
            showModernAlert('Logout realizado com sucesso!', 'success');

            // Delay to show the success message before logout
            setTimeout(() => {
                logout();
                navigate('/login');
            }, 1000);
        } catch (err) {
            console.error('Error during logout:', err);
            showModernAlert('Erro ao fazer o logout!', 'error');
        }
    };


    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className='mb-3'>
            <Navbar style={{ backgroundColor: '#003B6B', position: 'relative', padding: '0' }} expand="lg">
                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'relative',
                    paddingLeft: 'clamp(0.5rem, 2vw, 1rem)',
                    paddingRight: 'clamp(1rem, 4vw, 2rem)',
                    height: 'clamp(70px, 10vh, 100px)',
                    overflow: 'visible'
                }} className=''>

                    {/* Logo esquerdo - alinhado */}
                    <div className="d-none d-md-block" style={{
                        flexShrink: 0,
                        marginLeft: "8rem",
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <div style={{ position: 'relative', textAlign: 'left' }}>
                            <a className="navbar-brand" href="/" style={{ display: 'inline-block' }}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/image.png`}
                                    alt="logo icon"
                                    height="100"
                                    width="320"
                                    style={{
                                        height: 'clamp(60px, 100vh, 70px)',
                                        width: 'auto',
                                        maxWidth: '100%'
                                    }}
                                />
                            </a>
                        </div>
                    </div>

                    {/* Logo direito - posicionado à esquerda do dropdown */}
                    <div style={{
                        flexShrink: 0,
                        position: 'absolute',
                        right: '125px', // Posiciona à esquerda do dropdown (dropdown button width + margin)
                        top: '50%',
                        transform: 'translateY(-50%)'
                    }} className="d-none d-md-block">
                        <img
                            src={`${process.env.PUBLIC_URL}/logo_labrisco.png`}
                            alt="scoe icon"
                            height="100"
                            width="280"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </div>

                    {/* Mobile layout - center the logo */}
                    <div className="d-block d-md-none" style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center'
                    }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/logo_labrisco.png`}
                            alt="logo icon"
                            height="80"
                            width="200"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </div>
                </div>

                {/* User dropdown - no canto direito */}
                <div
                    className="user-dropdown-container aligne-itens-content me-2 "
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: '0rem', // Volta para o canto direito
                        transform: 'translateY(-50%)',
                        zIndex: 1000
                    }}
                    ref={dropdownRef}
                >
                    <button
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        style={{
                            color: 'white',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            background: 'rgba(255,255,255,0)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.5rem 0.75rem',
                            borderRadius: '0.75rem',
                            transition: 'all 0.3s ease',
                            border: 'none'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = 'rgba(255,255,255,0)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = 'rgba(255,255,255,0)';
                        }}
                    >
                        <div style={{
                            width: '3rem',
                            height: '3rem',
                            background: 'rgba(255,255,255,0)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}>
                            <PersonCircle size={42} style={{ color: 'white' }} />
                        </div>
                        {/* <div style={{ textAlign: 'left', minWidth: 0 }} className="d-none d-md-block">
                            <div style={{
                                color: 'white',
                                fontWeight: '600',
                                fontSize: '0.875rem',
                                lineHeight: '1.2',
                                marginBottom: '0.125rem',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '120px'
                            }}>
                                {accessToken.name || 'Usuário'}
                            </div>
                            <div style={{
                                color: 'rgba(255,255,255,0.8)',
                                fontSize: '0.75rem',
                                lineHeight: '1.2',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '120px'
                            }}>
                                {accessToken.email || 'email@example.com'}
                            </div>
                        </div> */}
                        <ChevronDown
                            size={24}
                            style={{
                                color: 'white',
                                transition: 'transform 0.3s ease',
                                transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                flexShrink: 0
                            }}
                        />
                    </button>

                    {/* CSS Styles */}
                    <style>
                        {`
                            .dropdown-menu-item {
                                width: 100%;
                                display: flex;
                                align-items: center;
                                gap: 0.75rem;
                                padding: 0.75rem 1rem;
                                background: none;
                                border: none;
                                text-align: left;
                                transition: background-color 0.2s ease;
                                cursor: pointer;
                            }

                            .dropdown-menu-item:hover {
                                background-color: var(--hover-bg) !important;
                            }

                            .dropdown-menu-item:focus {
                                outline: none;
                                background-color: var(--hover-bg) !important;
                            }

                            .dropdown-menu-item.tutorial {
                                --hover-bg: #f0f9ff;
                                color: #003B6B;
                            }

                            .dropdown-menu-item.logout {
                                --hover-bg: #fef2f2;
                                color: #dc2626;
                            }

                            @media (max-width: 768px) {
                                .user-dropdown-container {
                                    position: fixed !important;
                                    top: 1rem !important;
                                    right: 1rem !important;
                                    left: auto !important;
                                    transform: none !important;
                                }

                                .user-dropdown-menu {
                                    position: fixed !important;
                                    top: 4rem !important;
                                    right: 1rem !important;
                                    left: 1rem !important;
                                    width: auto !important;
                                    max-width: none !important;
                                    transform: none !important;
                                    margin-top: 0.25rem !important;
                                }

                                .user-dropdown-menu .dropdown-menu-item {
                                    padding: 1rem !important;
                                }
                            }

                            @media (max-width: 480px) {
                                .user-dropdown-menu {
                                    border-radius: 0.75rem !important;
                                    margin: 0.5rem !important;
                                    right: 0.5rem !important;
                                    left: 0.5rem !important;
                                }
                            }
                        `}
                    </style>

                    {/* Dropdown Menu */}
                    {isDropdownOpen && (
                        <div
                            className="user-dropdown-menu"
                            style={{
                                position: 'absolute',
                                right: 0,
                                top: '100%',
                                // marginTop: '0.5rem',
                                width: '280px',
                                maxWidth: '90vw',
                                background: 'white',
                                borderRadius: '1rem',
                                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                                border: '1px solid rgba(0, 0, 0, 0.1)',
                                overflow: 'hidden',
                                zIndex: 1050
                            }}
                        >
                            {/* User Info Header */}
                            <div style={{
                                background: 'linear-gradient(to right, #003B6B, #002a4d)',
                                padding: '1rem'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                    <div style={{
                                        width: '3rem',
                                        height: '3rem',
                                        background: 'rgba(255,255,255,0.2)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <PersonCircle size={24} style={{ color: 'white' }} />
                                    </div>
                                    <div>
                                        <div style={{
                                            color: 'white',
                                            fontWeight: '600',
                                            marginBottom: '0.125rem'
                                        }}>
                                            {user?.nome || 'Usuário'}
                                            <br />
                                            <p className='text-warning' style={{ marginBottom: 0 }}>
                                                {user?.acesso || 'Não definido'}
                                            </p>
                                        </div>
                                        <div style={{
                                            color: 'rgba(173, 216, 230, 1)',
                                            fontSize: '0.875rem'
                                        }}>
                                            {user?.email || 'email@example.com'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Menu Items */}
                            <div style={{ padding: '0.5rem 0' }}>

                                <button
                                    onClick={() => {
                                        navigate('/meu-perfil');
                                        setIsDropdownOpen(false);
                                    }}
                                    className="dropdown-menu-item tutorial"
                                >
                                    <div style={{
                                        width: '2rem',
                                        height: '2rem',
                                        background: '#dbeafe',
                                        borderRadius: '0.5rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <FaUser size={16} style={{ color: '#003B6B' }} />
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: '500', marginBottom: '0.125rem' }}>
                                            Meu Perfil
                                        </div>
                                        <div style={{
                                            fontSize: '0.75rem',
                                            color: '#6b7280'
                                        }}>
                                            Dados  de usuário
                                        </div>
                                    </div>
                                </button>

                                {(user?.acesso === 'Administrador' || user?.acesso === 'Verificado') && (
                                    <button
                                        onClick={() => navigate("/repositorio")}
                                        className="dropdown-menu-item tutorial"
                                    >
                                        <div style={{
                                            width: '2rem',
                                            height: '2rem',
                                            background: '#dbeafe',
                                            borderRadius: '0.5rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <Database size={16} style={{ color: '#003B6B' }} />
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: '500', marginBottom: '0.125rem' }}>
                                                Banco de Dados
                                            </div>
                                            <div style={{
                                                fontSize: '0.75rem',
                                                color: '#6b7280'
                                            }}>
                                                Atualizar BD
                                            </div>
                                        </div>
                                    </button>
                                )}

                                {user?.acesso === 'Administrador' && (
                                    <button
                                        onClick={() => {
                                            navigate('/gerenciar-usuarios');
                                            setIsDropdownOpen(false);
                                        }}
                                        className="dropdown-menu-item tutorial"
                                    >
                                        <div style={{
                                            width: '2rem',
                                            height: '2rem',
                                            background: '#dbeafe',
                                            borderRadius: '0.5rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <FaUsers size={16} style={{ color: '#003B6B' }} />
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: '500', marginBottom: '0.125rem' }}>
                                                Gerenciar Usuários
                                            </div>
                                            <div style={{
                                                fontSize: '0.75rem',
                                                color: '#6b7280'
                                            }}>
                                                Permissões de acesso
                                            </div>
                                        </div>
                                    </button>
                                )}

                                {(user?.acesso === 'Administrador' || user?.acesso === 'Verificado') && (
                                    <button
                                        onClick={() => {
                                            navigate('/previsoes');
                                            setIsDropdownOpen(false);
                                        }}
                                        className="dropdown-menu-item tutorial"
                                    >
                                        <div style={{
                                            width: '2rem',
                                            height: '2rem',
                                            background: '#dbeafe',
                                            borderRadius: '0.5rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <FaChartLine size={16} style={{ color: '#003B6B' }} />
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: '500', marginBottom: '0.125rem' }}>
                                                Experimental
                                            </div>
                                            <div style={{
                                                fontSize: '0.75rem',
                                                color: '#6b7280'
                                            }}>
                                                Acesso antecipado
                                            </div>
                                        </div>
                                    </button>
                                )}

                                <button
                                    onClick={() => {
                                        setShowManualModal(true);
                                        setIsDropdownOpen(false);
                                    }}
                                    className="dropdown-menu-item tutorial"
                                >
                                    <div style={{
                                        width: '2rem',
                                        height: '2rem',
                                        background: '#dbeafe',
                                        borderRadius: '0.5rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <FaBook size={16} style={{ color: '#003B6B' }} />
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: '500', marginBottom: '0.125rem' }}>
                                            Manual do Usuário
                                        </div>
                                        <div style={{
                                            fontSize: '0.75rem',
                                            color: '#6b7280'
                                        }}>
                                            Ajuda
                                        </div>
                                    </div>
                                </button>

                                <button
                                    onClick={handleLogout}
                                    className="dropdown-menu-item logout"
                                >
                                    <div style={{
                                        width: '2rem',
                                        height: '2rem',
                                        background: '#fee2e2',
                                        borderRadius: '0.5rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <BoxArrowRight size={16} style={{ color: '#dc2626' }} />
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: '500', marginBottom: '0.125rem' }}>
                                            Sair
                                        </div>
                                        <div style={{
                                            fontSize: '0.75rem',
                                            color: '#6b7280'
                                        }}>
                                            Fazer logout da conta
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    )}

                    {/* <h4 className='me-4 text-end rounded text-warning' style={{ backgroundColor: 'linear-gradient(135deg, #003B6B 0%, #0056b3 100%)' }}>HMG</h4> */}

                </div>

                {/* Versão do Sistema */}
                <div style={{
                    position: 'absolute',
                    bottom: '0',
                    right: '1rem',
                    zIndex: 999
                }}>
                    <span style={{
                        fontSize: '0.75rem',
                        color: 'white',
                        fontWeight: '500',
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                        lineHeight: '1',
                        margin: '0',
                        padding: '0',
                        display: 'inline-block'
                    }}>
                        {process.env.REACT_APP_VERSION}
                    </span>
                </div>

            </Navbar>

            {/* Modern Alert Notification */}
            {modernAlert.show && (
                <div
                    style={{
                        position: 'fixed',
                        top: '20px',
                        right: '20px',
                        zIndex: 10000,
                        minWidth: '300px',
                        maxWidth: '400px',
                        background: modernAlert.type === 'success' ?
                            '#003B6B' :
                            '#dc3545',
                        color: 'white',
                        padding: '16px 20px',
                        borderRadius: '12px',
                        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        animation: 'slideInRight 0.3s ease-out'
                    }}
                >
                    <div style={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        flexShrink: 0,
                        marginTop: '2px'
                    }}>
                        {modernAlert.type === 'success' ? '✓' : '✕'}
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '700', marginBottom: '0.25rem' }}>
                            {modernAlert.type === 'success' ? 'Sucesso!' : 'Erro!'}
                        </div>
                        <div style={{ opacity: 0.9, fontSize: '0.9rem' }}>
                            {modernAlert.message}
                        </div>
                    </div>
                    <button
                        onClick={() => setModernAlert({ show: false, type: '', message: '' })}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: 'white',
                            fontSize: '18px',
                            cursor: 'pointer',
                            padding: '0',
                            flexShrink: 0,
                            opacity: 0.7,
                            lineHeight: 1
                        }}
                        onMouseOver={(e) => e.target.style.opacity = '1'}
                        onMouseOut={(e) => e.target.style.opacity = '0.7'}
                    >
                        ×
                    </button>
                </div>
            )}

            <style>
                {`
                    @keyframes slideInRight {
                        from {
                            transform: translateX(100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(0);
                            opacity: 1;
                        }
                    }
                `}
            </style>

            {/* Modal do Manual do Usuário */}
            <UserManualModal
                show={showManualModal}
                onHide={() => setShowManualModal(false)}
            />

        </div>

    );
}

export default Header;